import { State } from '../@types';

export const selectConfig = (store: State) => store.config;
